"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const ProvisionalRateSheetFooter = () => (react_1.default.createElement("div", null, "* These provisional royalty statement rate calculation sheets are subject to change upon The MLC's completion of processing of corresponding usage files. The MLC will provide final royalty statement rate calculation sheets after such processing, which will supersede these provisional sheets and may contain different figures."));
exports.default = ProvisionalRateSheetFooter;
